import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractConfirmationServiceBase } from '@zero/shared/feature-contract-confirmation/base';
import { ContractConfirmationDialogComponent } from '../components/contract-confirmation-dialog/contract-confirmation-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ContractConfirmationService extends ContractConfirmationServiceBase {
  private readonly _modal = inject(NgbModal);

  public displayDialog(): void {
    this._modal.open(ContractConfirmationDialogComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });
  }
}
